// URL search params for feed routes, validated so a hand-typed URL can't put the board in an
// impossible state.
import { BOARD_TABS, type BoardTab } from "./selectors";

export interface FeedSearch {
  tab?: BoardTab | undefined;
}

/** Old links (`?tab=queued`, `?tab=working`) from before the two tabs merged. */
const RENAMED_TABS: Record<string, BoardTab> = { queued: "progress", working: "progress" };

export function parseFeedSearch(raw: Record<string, unknown>): FeedSearch {
  const tab = raw.tab;
  if (typeof tab !== "string") return {};
  const mapped = RENAMED_TABS[tab] ?? tab;
  return (BOARD_TABS as readonly string[]).includes(mapped) && mapped !== "review"
    ? { tab: mapped as BoardTab }
    : {};
}

export interface AuditSearch {
  card?: string | undefined;
}

export function parseAuditSearch(raw: Record<string, unknown>): AuditSearch {
  return typeof raw.card === "string" && raw.card.trim() ? { card: raw.card.trim() } : {};
}
